import { makeStyles } from '@material-ui/core/styles';

const tone = (backgroundColor, color) => ({ backgroundColor, color, '&::before': { backgroundColor: color } });

const styles = (theme) => ({
  panel: {
    ...theme.cardStyles.highlight,
    marginBottom: theme.spacing(6),
    overflow: 'hidden'
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(4, 4, 3)
  },
  title: {
    display: 'block'
  },
  count: {
    fontWeight: 400
  },
  seeAll: {
    color: theme.colors.action_icon,
    fontWeight: 600,
    whiteSpace: 'nowrap'
  },
  row: {
    height: 56
  },
  typeTag: {
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    fontSize: 11,
    borderRadius: theme.spacing(1),
    whiteSpace: 'nowrap'
  },
  nameCell: {
    display: 'flex',
    flexDirection: 'column'
  },
  name: {
    fontWeight: 600
  },
  subline: {
    fontSize: 12,
    color: theme.colorPalette.gray_03
  },
  idCell: {
    whiteSpace: 'nowrap'
  },
  id: {
    fontVariantNumeric: 'tabular-nums',
    marginRight: theme.spacing(1)
  },
  status: {
    whiteSpace: 'nowrap',
    gap: theme.spacing(1.5),
    '&::before': {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: '50%'
    }
  },
  positive: tone(theme.colorPalette.green_75_10, theme.colorPalette.green_75),
  pending: tone(theme.colorPalette.orange_50_op_10, theme.colorPalette.orange_50),
  negative: tone(theme.colorPalette.red_100_10, theme.colorPalette.red_100),
  neutral: tone(theme.colorPalette.beige_50, theme.colorPalette.gray_03),
  matchedOn: {
    fontSize: 12
  },
  date: {
    fontSize: 13,
    whiteSpace: 'nowrap'
  },
  muted: {
    color: theme.colorPalette.gray_03
  }
});

export default makeStyles(styles);
